import React from 'react';

// Chrome icons for the product's settings modals — close, back/forward chevrons, the
// disclosure caret, the drag handle and the row delete. They are stroke-only and inherit
// `currentColor`, so a styled wrapper decides the colour; nothing here is Contact-specific.
//
// Re-exported from ./index.js, which is the one import path the app uses for icons.

export const IconModalCloseSVG = ({ size = '14px' }) => (
  <svg width={size} height={size} viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2 2l11 11M13 2L2 13' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
  </svg>
);

export const IconChevronRightSVG = ({ size = '14px' }) => (
  <svg width={size} height={size} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5 2.5L9.5 7L5 11.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export const IconChevronLeftSVG = ({ size = '14px' }) => (
  <svg width={size} height={size} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M9 2.5L4.5 7L9 11.5' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

// Points down when collapsed; the caller rotates it 180° to mean "open".
export const IconChevronDownSVG = ({ size = '14px' }) => (
  <svg width={size} height={size} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3 5.25L7 9.25L11 5.25' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export const IconTrashLineSVG = ({ size = '13px' }) => (
  <svg width={size} height={size} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.5 4h9M5.5 4V2.6h3V4M4 4l.6 8h4.8L10 4' stroke='currentColor' strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

// Six dots — the affordance for a draggable list row.
export const IconDragDotsSVG = ({ width = '9px', height = '14px' }) => (
  <svg width={width} height={height} viewBox='0 0 9 14' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='2' cy='2' r='1.3' />
    <circle cx='7' cy='2' r='1.3' />
    <circle cx='2' cy='7' r='1.3' />
    <circle cx='7' cy='7' r='1.3' />
    <circle cx='2' cy='12' r='1.3' />
    <circle cx='7' cy='12' r='1.3' />
  </svg>
);

// A bare stroke, taking its colour from `currentColor`. Deliberately NOT named IconCheckSVG: that
// name is already a green "paid" badge declared further down ./index.js, and because a local export
// there shadows this file's star re-export, the collision would resolve to the badge with no build
// error at all — which is how it first shipped.
export const IconTickSVG = ({ size = '12px' }) => (
  <svg width={size} height={size} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2 6.2L4.6 8.8L10 3.4' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
